export const SALES_API_PATH = {
  GET_SALES_USAGE_SNAPSHOT: "v1/insights/{0}/sales-usage-snapshot/",
  GET_SALES_PRODUCTIVITY: "v1/insights/{0}/sales-productivity-snapshot/",
  SALES_MY_TEAM: "salesuser/sales-user-team/",
};
